import styled from 'styled-components';

export const IconContainer = styled.div`
    padding-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 32px;
`;

export const Item = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 160px;

    @media only screen and (min-width: 999px) {
        width: 180px;
    }
`;

export const ItemText = styled.p`
    text-align: center;
    margin-bottom: 0;
`;

export const Icon = styled.img`
    height: 32px;
`;
